import styled from 'styled-components';

export const ModalContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
`;

export const Title = styled.p`
	color: ${({ theme }) => theme.colors.principal.orion};
	font-size: 20px;
	font-weight: 500;
	line-height: 30px;
	margin-bottom: 8px;
	text-align: center;
`;

export const Subtitle = styled.p`
	color: ${({ theme }) => theme.colors.principal.vanth};
	font-size: 14px;
	font-weight: 400;
	line-height: 21px;
	text-align: center;

	&:last-of-type {
		margin-bottom: 32px;
		margin-top: 16px;
	}
`;

export const CreateContainer = styled.div`
	display: flex;

	div {
		&:last-of-type {
			background-color: ${({ theme }) => theme.colors.principal.air};
		}
	}
`;

export const ModalFooter = styled.div`
	align-items: center;
	display: flex;
	flex-direction: row;
	gap: 8px;
	justify-content: center;
	width: 100%;

	button {
		height: 48px;
		width: 100%;
	}
`;

export const MainSection = styled.div`
	${Subtitle} {
		text-align: left;
	}
`;

export const FormGroup = styled.div`
	display: flex;
	gap: 16px;
`;

export const SummarySection = styled.div`
	width: 100%;
`;

export const ButtonContainer = styled.div`
	margin-top: 32px;
`;

export const FeatureSectionTitle = styled.p`
	color: ${({ theme }) => theme.colors.principal.orion};
	font-size: 14px;
	font-weight: 400;
	line-height: 21px;
`;

export const ErrorMainSection = styled.article`
	display: flex;
	flex-direction: column;
	gap: 24px;
`;

export const ErrorHeader = styled.header`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;
export const ErrorTitle = styled.h2`
	color: ${({ theme }) => theme.colors.principal.orion};
	font-size: 20px;
	font-weight: 500;
	line-height: normal;
	text-align: center;
`;

export const ErrorSubtitle = styled.p`
	color: ${({ theme }) => theme.colors.principal.vanth};
	font-size: 16px;
	font-weight: 400;
	text-align: center;
`;

export const ErrorSpan = styled.span`
	color: ${({ theme }) => theme.colors.principal.orion};
	font-size: 16px;
	font-weight: 400;
	text-decoration: underline;
	text-decoration-style: solid;
`;

export const ErrorButtonContainer = styled.footer`
	display: flex;
	gap: 16px;
	justify-content: space-between;
`;

export const ErrorButton = styled.button`
	align-items: center;
	border-radius: 8px;
	cursor: pointer;
	display: flex;
	font-size: 16px;
	font-weight: 400;
	height: 48px;
	justify-content: center;
	max-width: 328px;
	padding: 8px 14px;
	width: 100%;
`;

export const CancelButton = styled(ErrorButton)`
	background-color: ${({ theme }) => theme.colors.principal.pure};
	border: 1px solid ${({ theme }) => theme.colors.principal.ceres};
	color: ${({ theme }) => theme.colors.principal.vanth};
`;

export const SendEmailButton = styled.a`
	align-items: center;
	background-color: ${({ theme }) => theme.colors.principal.orion};
	border: 1px solid ${({ theme }) => theme.colors.principal.orion};
	border-radius: 8px;
	color: ${({ theme }) => theme.colors.principal.pure};
	cursor: pointer;
	display: flex;
	font-size: 16px;
	font-weight: 400;
	height: 48px;
	justify-content: center;
	max-width: 328px;
	padding: 8px 14px;
	width: 100%;
`;
